var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FA_TIMES } from '../../../const/iconProps';
import H5 from '../../typography/H5';
import Button from '../../atoms/Button';
import { colors } from '../../../defaultTheme';
import query from '../../../const/mediaQueries';
import { sharedElementStyles } from './subcomponents';
const StyledTitle = styled(H5) `
  line-height: 32px;
`;
const StyledHeader = styled.div `
  justify-content: space-between;
  padding: 0 16px;
  min-height: 56px;
  flex-direction: row;
  background: ${colors.lightestGrey};
  border-bottom: 1px solid ${colors.lightGrey};
  box-sizing: border-box;
  ${sharedElementStyles}

  @media ${query.greaterThanMedium} {
    padding: 0px 24px;
  }
`;
const StyledClose = styled(Button) `
  margin: 0;
  padding: 0;
`;
const ModalHeader = (_a) => {
    var { hideClose, closeModal, content, className, headerRef, closeButtonAriaLabel = 'Close Dialog', dataType, dataTitle, dataReason } = _a, props = __rest(_a, ["hideClose", "closeModal", "content", "className", "headerRef", "closeButtonAriaLabel", "dataType", "dataTitle", "dataReason"]);
    return (React.createElement(StyledHeader, Object.assign({ className: className }, props),
        React.createElement(StyledTitle, { as: "h1", weight: "bold", tabIndex: -1, ref: headerRef }, content),
        !hideClose && (React.createElement(StyledClose, { alt: "close", "data-type": dataType, "data-title": dataTitle, "data-reason": dataReason, "data-object": "button", className: "ensightencustomevent", buttonType: "text", ariaLabel: closeButtonAriaLabel, onClick: () => closeModal && closeModal() },
            React.createElement(FontAwesomeIcon, { icon: FA_TIMES, size: "sm" })))));
};
export default ModalHeader;
